import { render, staticRenderFns } from "./processWorkList.vue?vue&type=template&id=1644d485&"
import script from "./processWorkList.vue?vue&type=script&lang=js&"
export * from "./processWorkList.vue?vue&type=script&lang=js&"
import style0 from "./processWorkList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "processWorkList.vue"
export default component.exports